<template>
  <!-- TODO: Duplicat function of `PulseBaseModal` -->

  <TransitionRoot :show="open" as="div" @after-leave="emit('after-leave')">
    <Dialog as="div" class="relative" style="z-index: 51" :initial-focus="search" @close="emit('close')">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div
          class="p-4 flex min-h-full"
          :class="{
            'justify-end': position === 'right',
            'justify-start': position === 'left',
            'justify-center items-center': position === 'center',
          }"
        >
          <DialogPanel
            class="bg-neutral-white rounded-xl shadow-xl flex flex-col overflow-hidden w-full"
            style="z-index: 52"
            v-bind="$attrs"
          >
            <div class="w-full px-8 py-3 border-b border-solid border-neutral-200">
              <PulseIconButton v-if="!hideCloseButton" icon="LineTimes" size="large" variant="secondary" @click="$emit('close')" />
            </div>

            <div class="h-full">
              <div class="flex-auto overflow-auto px-8 py-6 child" style="max-height: calc(100vh - 10.25rem)">
                <h3 v-if="$slots.header" class="text-2xl font-semibold font-geist mb-6">
                  <slot name="header" />
                </h3>
                <slot />
              </div>
            </div>
            <div
              v-if="$slots.footer"
              class="border-t border-solid border-neutral-200 flex items-center justify-end py-4 px-8"
            >
              <slot name="footer" />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts" setup>
import { TransitionRoot, TransitionChild, DialogPanel, Dialog } from '@headlessui/vue';
import { type PropType, ref, onMounted } from 'vue';

const search = ref<HTMLInputElement | null>(null);
const emit = defineEmits(['after-leave', 'close']);

defineProps({
  open: {
    default: false,
    type: Boolean,
  },
  position: {
    default: 'center',
    type: String as PropType<'right' | 'left' | 'center'>,
  },
  hideCloseButton: {
    default: false,
    type: Boolean,
  },
});

defineSlots();

onMounted(() => {
  window.addEventListener('keydown', e => {
    if (e.key === 'k' && e.metaKey) {
      emit('close');
    }
  });
});
</script>
